import RemainingMoves from './RemainingMoves'

export default RemainingMoves
